import { type ReactElement } from 'react'
import { useTranslation } from '@front/model'

const LOGO_HEIGHT = 9

export const TerrosHeaderLogo = (): ReactElement => {
  const { t } = useTranslation()
  return (
    <img
      alt={t('Terros logo')}
      className='pl-4'
      height={LOGO_HEIGHT}
      src='/logo-light.png'
      width={LOGO_HEIGHT * 17.2}
    />
  )
}
